import { IBadgeResource } from "../../badges";
import { EntityTypes } from "../../EntityTypes";
import { ISkillResource } from "../../skills";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapOrderedRelationAsIRIs, mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillDomain, ISkillDomainResource } from "../types";

export type ISkillDomainPatchMutationParameters = {
    data: {
        title?: string;
        shortTitle?: string;
        skills?: RelationalValue<ISkillResource>[];
        badges?: RelationalValue<IBadgeResource>[];
    };
    skillDomain: RelationalValue<ISkillDomainResource>;
};

export type ISkillDomainPatchMutationResult = ISkillDomain;

export const skillDomainPatchMutation: IApiMutationFunction<ISkillDomainPatchMutationParameters> = ({
    skillDomain,
    data: { title, shortTitle, skills, badges },
}) => {
    return {
        method: "PATCH",
        url: `/skill_domains/${mapRelationalValue(skillDomain)}`,
        data: {
            title,
            shortTitle,
            skills: mapOrderedRelationAsIRIs(EntityTypes.SKILL, skills),
            badges: mapOrderedRelationAsIRIs(EntityTypes.BADGE, badges),
        },
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
    };
};

export const useSkillDomainPatchMutation = createApiMutationHook<
    ISkillDomainPatchMutationParameters,
    ISkillDomainPatchMutationResult
>(skillDomainPatchMutation);
